var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{ref:"textarea",attrs:{"type":"textarea","placeholder":"请输入答题卡标题","resize":"none","autosize":"","id":"inputs"},on:{"change":_vm.editPrecautionsTitile},model:{value:(_vm.textareaVal),callback:function ($$v) {_vm.textareaVal=$$v},expression:"textareaVal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }